//Custom components
import NumericMetricWidget from '@/components/Widgets/NumericMetricWidget';

const AvgSalesPriceMarketRateWidget = ({ count }: { count: number | string }) => {
  return <NumericMetricWidget title='Avg. Sales Price - Market Rate' value={count} prefix='$' />;
};

export default AvgSalesPriceMarketRateWidget;
